import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const EditUserPage = withSuspense(
	lazy(async () => await import('./edit-user-page.component')),
	PageLoader,
);
